import styled from "@emotion/styled";

export const SinglePageWrapper = styled("div")`
label:SinglePageWrapper;
display: flex;
`